import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { navigationFor } from '@/config/navigation';
import type { UserRole } from '@/types/app';

interface SidebarProps {
  role: UserRole;
  onNavigate?: (() => void) | undefined;
}

export function Sidebar({ role, onNavigate }: SidebarProps) {
  const { t } = useTranslation();
  const items = navigationFor(role);

  return (
    <nav aria-label={t('nav.primary')} className="flex flex-col gap-1 p-3">
      {items.map(({ key, to, icon: Icon }) => (
        <NavLink
          key={key}
          to={to}
          end={to === '/'}
          onClick={onNavigate}
          className={({ isActive }) =>
            `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
              isActive ? 'bg-brand-50 text-brand-800' : 'text-slate-700 hover:bg-slate-100'
            }`
          }
        >
          <Icon className="size-4 shrink-0" aria-hidden="true" />
          <span className="truncate">{t(`nav.${key}` as 'nav.dashboard')}</span>
        </NavLink>
      ))}
    </nav>
  );
}
